import { table } from './_table';

export const media = {
  namespaced: true,
  modules: {
    table
  }
};
